import { useMemo } from "react";

import clsx from "clsx";

import OneSolutionLogoDark from "@onesolution/assets/one-solution-logo-dark.svg";
import OneSolutionLogoLight from "@onesolution/assets/one-solution-logo-light.svg";
import {
	useClientInfos,
	useDarkModeSSR,
	useIsMounted,
} from "@onesolution/hooks";

type LogoProps = {
	className?: string;
};

export default function Logo({ className }: LogoProps) {
	const { isDarkMode } = useDarkModeSSR();
	const clientInfos = useClientInfos();
	const isMounted = useIsMounted();

	const logo = useMemo(() => {
		if (clientInfos?.logo) return clientInfos.logo;

		return isDarkMode ? OneSolutionLogoDark : OneSolutionLogoLight;
	}, [clientInfos, isDarkMode]);

	if (!isMounted) return null;

	return (
		<div
			className={clsx(
				"flex items-start md:items-center w-full max-h-14 contain-content",
				className,
			)}
		>
			<img
				aria-label="One Solution Logo"
				src={logo}
				className="w-full max-h-14 md:w-fit md:max-h-full"
			/>
		</div>
	);
}
